<div
  class="tooltip"
  [style]="style"
  [class]="position + ' a-' + arrowPosition"
  [class.destroy]="destroy"
>
  <div class="title" [innerHTML]="title"></div>
  <div class="label" [innerHTML]="description"></div>
</div>
